import React, {Dispatch, Fragment, SetStateAction, useState, useEffect} from 'react';
import {FormikSetFieldValue} from '../../../types/CommonTypes';
import FilterDayCalendar from '../../Calendar/FilterDayCalendar';
import {useClickOutside} from '../../../hooks/useClickOutside';
import {useTranslation} from 'react-i18next';

interface Props {
	inputName: string;
	setFieldValue: FormikSetFieldValue;
	setValueDate?: Dispatch<SetStateAction<string>>;
	label: string;
	defaultDate?: string;
}

const FilterDay: React.FC<Props> = ({
	setFieldValue,
	inputName,
	label,
	defaultDate,
	setValueDate,
}) => {
	const {t} = useTranslation();
	const [openCalendar, setOpenCalendar] = useState(false);
	const [currentDayName, setCurrentDayName] = useState<string>(
		defaultDate ?? t('Обрати'),
	);

	// Синхронизируем currentDayName с defaultDate
	useEffect(() => {
		if (defaultDate) {
			setCurrentDayName(defaultDate);
		} else {
			setCurrentDayName(t('Обрати'));
		}
	}, [defaultDate, t]);

	const handleCloseCategoryList = () => {
		setOpenCalendar(false);
	};
	const containerRef = useClickOutside<HTMLDivElement>(handleCloseCategoryList);
	const handleClickInput = () => {
		setOpenCalendar(true);
	};
	return (
		<>
			<div className="item-select2__label">{label}</div>
			<div ref={containerRef}>
				<button
					className="form-filter__select2"
					type="button"
					onClick={handleClickInput}
				>
					{currentDayName}
				</button>
				{openCalendar && (
					<FilterDayCalendar
						setValueDate={setValueDate}
						close={setOpenCalendar}
						setFieldValue={setFieldValue}
						fieldName={inputName}
						setCurrentDayName={setCurrentDayName}
					/>
				)}
			</div>
		</>
	);
};

export default FilterDay;
